import React from 'react';
import { DmnSymbolId } from '../../data/dmnSymbols';
import { DMN_ICON_MARKUP } from '../../data/dmnIconMarkup';
import { NotationSymbolIcon } from './NotationSymbolIcon';

interface DmnSymbolIconProps {
  symbolId: DmnSymbolId;
  size?: number;
  className?: string;
}

export const DmnSymbolIcon: React.FC<DmnSymbolIconProps> = ({ symbolId, size, className }) => {
  const icon = DMN_ICON_MARKUP[symbolId];
  if (!icon) return null;

  const fillParent = Boolean(className?.includes('w-full') || className?.includes('h-full'));

  return (
    <NotationSymbolIcon
      viewBox={icon.viewBox}
      markup={icon.markup}
      size={fillParent ? undefined : size ?? 40}
      className={className ?? (fillParent ? 'w-full h-full' : undefined)}
      idPrefix={`dmn-${symbolId}`}
      stretch={false}
    />
  );
};

export default DmnSymbolIcon;
